import QuickOrderProductSelector from "@dana/Components/QuickOrderProductSelector";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import siteMessage from "@insite/client-framework/SiteMessage";
import addProduct from "@insite/client-framework/Store/Pages/QuickOrder/Handlers/AddProduct";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductSelector, { ProductSelectorStyles } from "@insite/content-library/Components/ProductSelector";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import React, { useContext } from "react";
import { connect, ResolveThunks } from "react-redux";
import { getDanaGeneralSettings } from "@dana/Store/Context/ContextSelectors";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";

const mapStateToProps = (state: ApplicationStateDana) =>({
    danaGeneralSettings: getDanaGeneralSettings(state)
});

const mapDispatchToProps = {
        addProduct,   
       };

type Props = WidgetProps &  ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface QuickOrderSearchStyles {
    productSelector?: ProductSelectorStyles;
}

export const quickOrderSearchStyles: QuickOrderSearchStyles = {};

const styles = quickOrderSearchStyles;

const QuickOrderSearch = ({ addProduct, danaGeneralSettings }: Props) => {
    const toasterContext = useContext(ToasterContext);

    const addProductToOrder = (productInfo: ProductInfo, product: ProductModel) => {
        addProduct({ productInfo, product });
        toasterContext.addToast({ body: translate("Item Added"), messageType: "success" });
    };

    return (
        <>
        {danaGeneralSettings?.enableNewQuickOrderFeature ? (        
        <QuickOrderProductSelector
            selectButtonTitle={translate("Add to Cart")}
            onSelectProduct={addProductToOrder}
            productIsConfigurableMessage={siteMessage("QuickOrder_CannotOrderConfigurable")}
            productIsUnavailableMessage={siteMessage("QuickOrder_ProductIsUnavailable")}
            extendedStyles={styles.productSelector}
        />):
        (
         <ProductSelector
     selectButtonTitle={translate("Add to Order")}
     onSelectProduct={addProductToOrder}
     productIsConfigurableMessage={siteMessage("QuickOrder_CannotOrderConfigurable")}
     productIsUnavailableMessage={siteMessage("QuickOrder_ProductIsUnavailable")}
     extendedStyles={styles.productSelector}
     /> 
        )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(QuickOrderSearch),
    definition: {
        group: "Quick Order",
        allowedContexts: ["QuickOrderPage"],
    },
};

export default widgetModule;
